import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

import Login from './components/security/Login';
import Dashboard from './components/dashboard/Dashboard';
import TopNavigation from './components/common/TopNavigation';
import GetSignature from './components/template/GetSignature';
import Organization from './components/organization/Organization';
import DocTemplateList from './components/template/DocTemplateList';
import StaffList from './components/security/StaffList';
import UpdateStaff from './components/security/UpdateStaff';
import SignatureRequestDetails from './components/template/SignatureRequestDetail'
import ForgotPassword from './components/security/ForgotPassword';
import ResetPassword from "./components/security/ResetPassword";
import Footer from "./components/common/Footer";
import * as Util from "./components/common/Util";
import HtmplTemplateList from "./components/template/HtmlTemplateList";
import BlubillingConf from "./components/organization/BlubillingConf";
import EmailConf from "./components/organization/EmailConf";
import './App.css';
import * as ApiConfig from './api-config';
import { HashRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import DocTemplateUsers from "./components/template/DocTemplateUsers";
import Page401 from "./components/errorsPage/401";
import Page403 from "./components/errorsPage/403";
import Page404 from "./components/errorsPage/404";
import SignatureSetting from "./components/organization/SignatureSetting";
import PaymentProcessorConfiguration from "./components/organization/PaymentProcessorConfiguration";
import Payments from "./components/payment/Payments";
import Payment from "./components/payment/Payment";
import CreateOrg from "./components/organization/CreateOrg";
import ProcessPayment from "./components/payment/ProcessPayment"
import SalesforceConfiguration from "./components/organization/SalesforceConfiguration"
import IntermediateLogin from "./components/security/IntermediateLogin"

class App extends Component {

    static api = ApiConfig.API_ROOT;
    static backEndServerUrl = ApiConfig.BACKEND_SERVER;
    static backEndServerUrlWithoutDomain = ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN;

    state = {
        api: "",
        backEndServerUrl: "",
        backEndServerUrlWithoutDomain: "",
        authentication: {
            jwtToken: "",
            roles: [],
            fullName: null
        },
        organization: {},
        topNavigationMenu: {},
        message: '',
        logoUrl: ''
    };

    constructor() {
        super();
        let authenticationJSON = JSON.parse(localStorage.getItem('authentication'));
        // build the real api uri
        let domain = Util.getDomain();
        this.state.api = App.api.replace("xxxxx", domain);
        this.state.backEndServerUrl = App.backEndServerUrl.replace("xxxxx", domain);
        this.state.backEndServerUrlWithoutDomain = App.backEndServerUrlWithoutDomain
        if (authenticationJSON) {
            this.state.authentication = authenticationJSON;
        } else {
            this.handleLogout();
        }
        this.handleSetAuthentication = this.handleSetAuthentication.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.fetchOrganization = this.fetchOrganization.bind(this);
        this.checkImage = this.checkImage.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this)
    }

    handleLogoChange() {
        var thizz = this
        thizz.checkImage(thizz.state.backEndServerUrl + '/esign/' + thizz.state.organization.domainPrefix + '/logo/org_logo.jpg', function (url, status) {
            if (status !== "success") {
                thizz.checkImage(thizz.state.backEndServerUrl + "/img/blusynergy_logo.png", function (url, status) {
                    thizz.setState({ logoUrl: url });
                });
            } else {
                thizz.setState({ logoUrl: url });
            }
        });
    }
    checkImage(url, callback) {
        var timeout = 5000;
        var timedOut = false, timer;
        var img = new Image();
        img.onerror = img.onabort = function () {
            if (!timedOut) {
                clearTimeout(timer);
                callback(url, "error");
            }
        };
        img.onload = function () {
            if (!timedOut) {
                clearTimeout(timer);
                callback(url, "success");
            }
        };
        img.src = url;
        timer = setTimeout(function () {
            timedOut = true;
            callback(url, "timeout");
        }, timeout);
    }

    handleSetAuthentication(authentication) {
        var roles = [];
        authentication.roles.map((role, index) =>
            roles.push(role)
        );
        this.setState({ authentication: authentication });

        localStorage.setItem("authentication", JSON.stringify(authentication));
        localStorage.setItem("roles", JSON.stringify(roles));
        this.fetchOrganization();
        this.fetchTopNavigationMenu();
    }

    handleLogout(messageText, id) {
        let _this = this;
        if (messageText !== undefined && messageText + "" !== "[object Object]".toString()) {
            const message = messageText;
            this.setState({ message: message });
        }
        if (id === "logout" && id !== undefined) {
            localStorage.clear();
            const authentication = {
                jwtToken: "",
                roles: [],
                fullName: null
            }
            _this.setState({ authentication: authentication })
        }
        if (_this.state.authentication.jwtToken && (id === "" || id === undefined)) {
            let body = {
                token: _this.state.authentication.jwtToken,
            };
            fetch(_this.state.api + '/login/logout', {
                body: JSON.stringify(body),
                method: "POST",
                mode: 'cors',
                headers: {
                    'content-type': 'application/json',
                    "X-AUTH-TOKEN": _this.state.authentication && this.state.authentication.jwtToken,
                }
            }).then(response => {
                return response.json()
            })
                .then(json => {
                    console.log(json);
                    if (json.isError === false) {
                        localStorage.clear();
                        const authentication = {
                            jwtToken: "",
                            roles: [],
                            fullName: null
                        }
                        _this.setState({ authentication: authentication });
                        if (this.state.message === "") {
                            const message = json.message;
                            _this.setState({ message: message });
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            localStorage.clear();
            const authentication = {
                jwtToken: "",
                roles: [],
                fullName: null
            }
            _this.setState({ authentication: authentication })
        }

    }
    componentWillMount() {
        this.fetchOrganization();
        if (this.state.authentication.jwtToken) {
            this.fetchTopNavigationMenu();
        }
    }

    fetchTopNavigationMenu() {
        fetch(this.state.api + '/dashboard/fetchTopNavigationMenu', {
            method: 'GET',
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.state.authentication.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else {
                    console.debug(json)
                    this.setState({ topNavigationMenu: json });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    fetchOrganization() {
        if (this.state.authentication.jwtToken) {
            fetch(this.state.api + '/organization', {
                method: "GET",
                mode: 'cors',
                headers: {
                    "X-AUTH-TOKEN": this.state.authentication.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    console.log(json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.handleLogout(json.message);
                    } else {
                        var thizz = this
                        this.setState({ organization: json }, function () {
                            thizz.checkImage(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/esign/' + thizz.state.organization.domainPrefix + '/logo/org_logo.jpg', function (url, status) {
                                if (status !== "success") {
                                    thizz.checkImage(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + "/img/blusynergy_logo.png", function (url, status) {
                                        thizz.setState({ logoUrl: url });
                                    });
                                } else {
                                    thizz.setState({ logoUrl: url });
                                }
                            });
                        })
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <HashRouter>
                    <div style={{ background: this.state.authentication.jwtToken.length > 0 ? '' : '' }}>

                        {
                            (0 === this.state.authentication.jwtToken.length && window.location.href.indexOf("resetPassword") <= 0 && window.location.href.indexOf("createOrg") <= 0 && (window.location.href.indexOf("/login/auto") <= 0)) ? (<Redirect to='/login' />) : null
                        }

                        <Route exact path="/" render={() => (
                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication && this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />

                                <Dashboard api={this.state.api} authentication={this.state.authentication}
                                    onLogoutClick={this.handleLogout}
                                    msg={t}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication && this.state.authentication.jwtToken}
                                    user={this.state.authentication && this.state.authentication} />
                                <Footer msg={t} />
                            </div>

                        )} />
                        <Route exact path="/msg/:value?" render={({ match }) => (
                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication && this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />

                                <Dashboard api={this.state.api} authentication={this.state.authentication}
                                    onLogoutClick={this.handleLogout}
                                    msg={t}
                                    params={match.params}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication && this.state.authentication.jwtToken} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/login/:msgType?/:id?" render={({ match }) => (
                            <div id="page-wrapper" className="gray-bg">
                                <Login api={this.state.api}
                                    jwtToken={this.state.authentication && this.state.authentication.jwtToken}
                                    onSetAuthentication={this.handleSetAuthentication}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    onLogoutClick={this.handleLogout}
                                    message={this.state.message}
                                    isLogout={match.params}
                                    msg={t} logoUrl={this.state.logoUrl} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/forgotPassword" render={() => (
                            <div id="page-wrapper" className="gray-bg">
                                <ForgotPassword api={this.state.api} msg={t} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/resetPassword/:tracking" render={({ match }) => (
                            <div>

                                <ResetPassword api={this.state.api} params={match.params} msg={t} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/getSignature/:id?" render={({ match }) => (
                            <div id="page-wrapper" className="gray-bg">

                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <GetSignature api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken}
                                    tid={match.params}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    msg={t}
                                    authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>

                        )} />

                        <Route exact path="/organization" render={() => (



                            <div id="page-wrapper" className="gray-bg">

                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization}
                                    onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Footer msg={t} />
                                <Organization api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    msg={t} onLogoChange={this.handleLogoChange}
                                    authentication={this.state.authentication} />
                            </div>

                        )} />

                        {/*<Route exact path="/signature/list" render={ () => (

                                <div id="page-wrapper" className="gray-bg">
                                    <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                                   organization={this.state.organization}
                                                   onLogoutClick={this.handleLogout}
                                                   msg={t}
                                                   logoUrl={this.state.logoUrl}
                                                   backEndServerUrl={this.state.backEndServerUrl}
                                                   jwtToken={this.state.authentication.jwtToken}/>
                                    <SignatureRequestList api={this.state.api}
                                                          template={this.state.template}
                                                          jwtToken={this.state.authentication.jwtToken} backEndServerUrl={this.state.backEndServerUrl}
                                                          onLogoutClick={this.handleLogout}
                                                          organization={this.state.organization}
                                                          msg={t}
                                                          authentication={this.state.authentication}/>
                                    <Footer msg={t}/>
                                </div>

                        )}/>*/}

                        <Route exact path="/template/list" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization}
                                    onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <DocTemplateList api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    template={this.state.template}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t}
                                    authentication={this.state.authentication} />

                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/template/:id/users/" render={({ match }) => (


                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation
                                    topNavigationMenu={this.state.topNavigationMenu}
                                    user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <DocTemplateUsers api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken} tid={match.params}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/staff/list/:msg?" render={({ match }) => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation
                                    topNavigationMenu={this.state.topNavigationMenu}
                                    user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <StaffList api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    params={match.params}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/staff/create" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation
                                    topNavigationMenu={this.state.topNavigationMenu}
                                    user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <UpdateStaff api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/staff/update/:id" render={({ match }) => (


                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation
                                    topNavigationMenu={this.state.topNavigationMenu}
                                    user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <UpdateStaff api={this.state.api}
                                    jwtToken={this.state.authentication.jwtToken} tid={match.params}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    onSetAuthentication={this.handleSetAuthentication}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/esignatureDetail/:id" render={({ match }) => (


                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation
                                    topNavigationMenu={this.state.topNavigationMenu}
                                    user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <SignatureRequestDetails api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} tid={match.params}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/htmlTemplate/list" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <HtmplTemplateList api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    template={this.state.template}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    authentication={this.state.authentication}
                                    msg={t} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/blubillingConfig" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <BlubillingConf api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    template={this.state.template}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/emailConfiguration" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <EmailConf api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    template={this.state.template}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/401" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Page401 api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/404" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Page404 api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/403" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Page403 api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/signatureSetting" render={() => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <SignatureSetting api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/paymentProcessorConfiguration/:msg?" render={({ match }) => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <PaymentProcessorConfiguration api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} params={match.params} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/salesforceConfiguration" render={({ match }) => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <SalesforceConfiguration api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} params={match.params} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/payment/list/:msgType?/:msg?" render={({ match }) => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Payments api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} params={match.params} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />

                        <Route exact path="/payment/detail/:id" render={({ match }) => (

                            <div id="page-wrapper" className="gray-bg">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <Payment api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} params={match.params} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                        <Route exact path="/organization/createOrg" render={({ match }) => (
                            <div id="page-wrapper" className="gray-bg create-orgPage">
                                <CreateOrg api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    backEndServerUrlWithoutDomain={this.state.backEndServerUrlWithoutDomain}
                                    msg={t} />
                            </div>
                        )} />
                        <Route exact path="/signature/processPayment/:signatureRequestId" render={({ match }) => (
                            <div id="page-wrapper" className="gray-bg create-orgPage">
                                <TopNavigation topNavigationMenu={this.state.topNavigationMenu} user={this.state.authentication}
                                    organization={this.state.organization} onLogoutClick={this.handleLogout}
                                    msg={t}
                                    logoUrl={this.state.logoUrl} backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken} />
                                <ProcessPayment api={this.state.api}
                                    backEndServerUrl={this.state.backEndServerUrl}
                                    jwtToken={this.state.authentication.jwtToken}
                                    onLogoutClick={this.handleLogout}
                                    organization={this.state.organization}
                                    msg={t} params={match.params} authentication={this.state.authentication} />
                                <Footer msg={t} />
                            </div>
                        )} />
                          <Route exact path="/intermediateLogin/:jwtToken" render={ ({match}) => (
                            <div id="page-wrapper" className="gray-bg">
                                <IntermediateLogin
                            params={match.params}
                            api={this.state.api}
                            onSetAuthentication={this.handleSetAuthentication}
                            onLogoutClick={this.handleLogout}
                            />
                            </div>
                        )}/>
                    </div>
                </HashRouter>
            </div>
        )
    }
}

//export default App;
export default withTranslation('message')(App);


// WEBPACK FOOTER //
// ./src/App.js